import { Button, Flex } from 'antd';
import React, { useEffect, useState } from 'react';
import MainCard from 'components/MainCard';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import ComptrollerConfirmModal from '../ComptrollerConfirmModal';
import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';
import comptroller from 'assets/images/comptroller_white.svg';
import GraphForm from './graph-form';
import { toast } from 'react-toastify';

import { toastConfig } from 'config';
import { useAddGraphDefinationMutation } from 'store/features/comptroller/comptrollerApi';
import DetailPageHeader from 'components/header/DetailPageHeader';
import FormSubmitButton from 'components/button/FormSubmitButton';
import SectionCard from 'components/section/SectionCard';

function CreateGraph() {
	const navigate = useNavigate();
	const theme = useTheme();

	// const [activate, setActivate] = useState(true);
	const activate = true;
	// console.log(setActivate);

	const [submitForm, setSubmitForm] = useState(false);

	const [showModal, setShowModal] = useState(false);

	const [modalInfo, setModalInfo] = useState(null);

	const [submitData, setSubmitData] = useState(null);

	const companyCode = useSelector((state) => state?.profile?.profileData?.creatorOrganizationId);

	const [AddGraphDefination, { data: graphDefinationData }] = useAddGraphDefinationMutation();

	const handleModalSubmit = (data) => {
		setSubmitData(data);
		setShowModal(true);

		setModalInfo({
			head: 'Module',
			action: 'submit',
		});
	};

	useEffect(() => {
		if (submitForm && submitData && companyCode) {
			submitHandle(submitData);
		} //eslint-disable-next-line
	}, [submitForm]);

	const submitHandle = (formData) => {
		const payload = {
			companyCode: companyCode,
			graphName: formData.graphName,
			graphDescription: formData.graphDescription,
			graphType: formData.graphType,
			graphQuery: formData.graphQuery,
		};
		AddGraphDefination(payload);
	};

	useEffect(() => {
		if (graphDefinationData) {
			if (graphDefinationData?.code === '200') {
				toast.success('Graph Defination Added Successfully', toastConfig);
				navigate(-1);
			} else {
				toast.error('Failed to add Graph Defination', toastConfig);
			}
		} //eslint-disable-next-line
	}, [graphDefinationData]);

	const childernOne = (
		<GraphForm handleModalSubmit={handleModalSubmit}>
			<FormSubmitButton />

			{/* <Flex justify="flex-end" align="flex-end">
				<Button
					className="animated-button"
					style={{ backgroundColor: activate ? '' : theme.palette.lynTheme.submit }}
					type="primary"
					htmlType="submit"
				>
					Submit
				</Button>
			</Flex> */}
		</GraphForm>
	);

	return (
		<Grid container rowSpacing={4.5} columnSpacing={2.75}>
			<Grid item xs={24} lg={24}>
				<DetailPageHeader title="Create Graph Definition" />

				<SectionCard>{childernOne}</SectionCard>

				{showModal && (
					<ComptrollerConfirmModal showModal={showModal} setShowModal={setShowModal} setSubmitForm={setSubmitForm} modalData={modalInfo} />
				)}
			</Grid>
		</Grid>
	);
}

export default CreateGraph;
